import React from 'react';
const UserDashboard: React.FC = () => <div>User Dashboard</div>;
export default UserDashboard;